/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import officeReunion from './officeReunion.jpg';

const buildingImageStyle: ouiStyle.InStyle = {
  widthLines: 'screenWidth',
  paddingVertical: 'double',
  lines: 10,
  backgroundSize: 'cover',
  backgroundAttachment: 'fixed',
  backgroundImage: `url(${officeReunion})`,
};

const buildingImageCss = ouiStyle.makeCss(buildingImageStyle);

export const OfficeImage = () => (
  <div
    css={buildingImageCss}
  />
);
